const env = process.env.REACT_APP_IA_ENV || 'local';

export function envswitch<T>(vals: { local?: T, stg?: T, prod?: T, test?: T }): T {
  const envName = {
    staging: 'stg',
    production: 'prod',
  }[env] || env;
  const res = (vals as any)[envName];
  if (res === undefined) {
    throw new Error(`No value specified for env '${env}' in ${JSON.stringify(vals)}`);
  }
  return res;
}

export class Config {
  ENV = env;

  HTTP_PORT = 1489;

  COMMIT_SHA = process.env.REACT_APP_COMMIT_SHA || 'local';
  BUILD_DATE = process.env.REACT_APP_BUILD_DATE || 'local';
  RELEASE = process.env.REACT_APP_RELEASE || (
    this.BUILD_DATE == 'local'
      ? 'local'
      : `${this.BUILD_DATE}/${this.COMMIT_SHA.slice(0, 7)}`
  );

  API_URL = envswitch({
    local: 'http://localhost:1489/',
    //local: 'https://stg-notification-engine.rxdev.co/',
    stg: 'https://stg-notification-engine.rxdev.co/',
    prod: 'https://notification-engine.rxfoodapp.com/',
  });

  IS_LOCAL = envswitch({
    local: true,
    stg: false,
    prod: false,
    test: false,
  });

  IS_DEV = envswitch({
    local: true,
    stg: true,
    prod: false,
    test: false,
  });

  IS_PROD = envswitch({
    local: false,
    stg: false,
    prod: true,
    test: false,
  });

  IS_TEST = envswitch({
    local: false,
    stg: false,
    prod: false,
    test: true,
  });
}

export const config = new Config();
